import superModule from "./superModule";
import o1MessageBox from "./uiModule/o1MessageBox";
import o1DialogBox from "./uiModule/o1DialogBox";
import o1Loading from "./uiModule/o1Loading";
import O1HD from "../gameEngine";
import RewardView from "../../O1ModuleRes/control/RewardView";
import {REWARD_TYPE} from "../services/userContent/userInterface";
import addUserProp from "../../O1ModuleRes/control/addUserProp";
import o1SelectBox from "./uiModule/o1SelectBox";
import PageBase from "./uiModule/PageBase";
import { IAddUserPropPrams, IDialogPrams, IPagePramsBase, IRewardViewPrams } from "./uiModule/UIPrams";

export enum UI_Z_INDEX {
    NORMAL,
    DIALOG = 10,
    LOADING,
    MESSAGE,
}

export enum PAGE{
    DIALOG_SELECT="frame/o1SelectBox",
    DIALOG_DIALOG='frame/o1DialogBox',
    DIALOG_INFINITYPOWER='infinitypower',
    DIALOG_ADDUSERPROP = 'control/addUserProp',
    DIALOG_REWARDVIEW = 'control/RewardView'
}

interface IPageMap {
    [pageName: string]: PageBase;
}

export default class uiModule extends superModule {

    protected m_className: string = 'UI模块';

    //
    private readonly m_publicFontBundle: string = 'o1FontRes';
    //
    private readonly m_pathFrameBundle: string = 'o1ModuleRes';
    //
    private readonly m_pathGameBundle: string = 'gameBundle';
    //
    private readonly m_pathPreloadFrame: string = 'preload/frame';
    //
    private readonly m_pathPreloadGame: string = 'preload';

    private readonly InfinityModel: string = 'user-is-infinity';
    private readonly InfinityPower_Key: string = 'user-logintime';

    //全局框架bundle
    private m_frameBundle: cc.AssetManager.Bundle = null;
    //游戏公用bundle
    private m_gameBundle: cc.AssetManager.Bundle = null;

    constructor() {
        super();
    }

    private m_uiRoot : cc.Node = null;
    
    private m_currDialog : PageBase = null;
    private m_dialogList : PageBase[] = [];
    private m_loadingPage : string[] = [];
    private pageMap : IPageMap = <IPageMap>{};
    
    private m_uiBgTexture: cc.RenderTexture = null;
    private m_uiBgSpriteFrame = null;
    //设置高模
    setGaussianMode(bgNode: cc.Node) {
        return;
        //暂时不需要
        // //
        // if (!bgNode.isValid) return;
        // //
        // this.changeCurrCanvasPicture();
        // //高斯模糊
        // if (bgNode) {
        //     bgNode.getComponent(cc.Sprite).spriteFrame = this.m_uiBgSpriteFrame;
        // }
        // // }, 0.01666);
    }

    public getUIRoot(){
        return this.m_uiRoot;
    }
    public SetUIRoot(node:cc.Node){
        this.m_uiRoot = node;
    }

    // private changeCurrCanvasPicture() {
    //     if (this.m_uiBgTexture) {
    //         delete this.m_uiBgTexture;
    //     }
    //     if (this.m_uiBgSpriteFrame) {
    //         delete this.m_uiBgSpriteFrame;
    //     }
    //     //
    //     this.m_uiBgTexture = new cc.RenderTexture();
    //     this.m_uiBgTexture.initWithElement(cc.game.canvas);
    //     this.m_uiBgSpriteFrame = new cc.SpriteFrame(this.m_uiBgTexture);
    // }

    //预加载框架资源路径
    getFrameBundlePreloadResPath(): string {
        return this.m_pathPreloadFrame;
    }

    //预加载游戏资源路径
    getGameBundlePreloadResPath(): string {
        return this.m_pathPreloadGame;
    }

    async preLoadModules(): Promise<void> {
        return super.preLoadModules();
    }

    async loadModule(): Promise<void> {
        return super.loadModule();
    }

    public GetPage<T extends PageBase>(pageName:string,type:{prototype : T}):T{
        const page : PageBase = this.pageMap[pageName];
        if(!page){
            this.Warn("不存在这个页面的实例",pageName);
        }
        return <T>page;
    }

    private dialogIndex : number = 0;

    async OpenPage<T extends PageBase>(
        pageName:string 
        , pageIndex:UI_Z_INDEX
        , prams?:IPagePramsBase
        , bundle?: cc.AssetManager.Bundle
        , bUsePageName: boolean = false
        , bUsePageInedx: boolean = false
    ):Promise<T>{
        const dialogFlag : boolean = pageIndex == UI_Z_INDEX.DIALOG;
        this.Log("尝试打开",pageName,dialogFlag);
        let subDialog : number = 0;
        if(dialogFlag){
            this.dialogIndex++;
            subDialog = this.dialogIndex;
            // this.Log("多开弹窗",pageName,this.dialogIndex);
        }
        if (bUsePageInedx) {
            subDialog = pageIndex;
        }
        if(this.pageMap[pageName]){
                this.Log("从隐藏打开",pageName);
                this.pageMap[pageName].node.active = true;
                // this.pageMap[pageName].node.zIndex = this.pageMap[pageName].node.parent.childrenCount;
                this.pageMap[pageName].OnPageOpen(prams);
                return;
            
        }
        const realPageName : string = dialogFlag ? pageName+subDialog.toString() : pageName;
        if(this.m_loadingPage.includes(realPageName)&&!dialogFlag){
            this.Warn("正在加载页面，不要重复打开");
            return;
        }
        this.m_loadingPage.push(realPageName);
        return new Promise<T>((resolve,reject)=>{
            bundle = bundle || this.m_frameBundle;

            let pathName = `preload/${pageName}`;
            if (bUsePageName) {
                pathName = pageName;
            }
            bundle.load(pathName,async (err,prefab:cc.Prefab)=>{
                if(err){
                    reject(err);
                    console.error("页面加载错误",err);
                    return;
                }

                let page = cc.instantiate(prefab);
                let com = page.getComponent(PageBase);
                if(!com){this.Warn("页面没有挂载脚本!!!",pageName);}
                com.pageIndex = pageIndex;
                this.pageMap[realPageName] = com;
                // this.Log("加入新的弹窗",realPageName);
                com.pageName = pageName;
                com.dialogIndex = subDialog;
                // let name : string = 'UILayer';
                this.getUIRoot().addChild(page,com.pageIndex);
                let index = this.m_loadingPage.indexOf(realPageName);
                if(index>-1){
                    this.m_loadingPage.splice(index);
                }

                if(dialogFlag){
                    if(this.m_currDialog){
                        this.HidePage(this.m_currDialog.pageName+this.m_currDialog.dialogIndex.toString());
                        this.m_dialogList.push(this.m_currDialog);
                        // this.Log("折叠弹窗",realPageName);
                    }
                    this.m_currDialog = com;
                    // this.Log("设置新的当前弹窗",subDialog);
                }

                await com.OnPageOpen(prams);

                resolve(com as T);
            });
        });
    }

    ShowPage(pageName:string){
        // console.log("尝试显示",pageName);
        
        if(this.pageMap[pageName]){
            this.pageMap[pageName]?.OnPageOpen();
            // this.pageMap[pageName].OnPageClose();
        }
    }

    HidePage(pageName:string){
        if(this.pageMap[pageName]){
            this.pageMap[pageName].HidePage();
            // this.pageMap[pageName].OnPageClose();
        }
    }

    ClosePage(pageName:string){
        this.Log("尝试关闭",pageName);
        if(this.pageMap[pageName]){
            if(this.pageMap[pageName]?.pageIndex == UI_Z_INDEX.DIALOG){
                const nextDialog = this.m_dialogList.pop();
                this.Log("展开一个弹窗",nextDialog?.pageName,nextDialog?.dialogIndex);
                if(nextDialog){
                    this.ShowPage(nextDialog.pageName+nextDialog.dialogIndex.toString());
                    this.m_currDialog = nextDialog;
                }
            }
            this.pageMap[pageName].OnPageClose();
            this.pageMap[pageName] = null;
            delete this.pageMap[pageName];
        }
    }

    CloseAllPage(){
        this.m_currDialog = null;
        this.m_dialogList = [];
        for (const key in this.pageMap) {
            if (Object.prototype.hasOwnProperty.call(this.pageMap, key)) {
                const element = this.pageMap[key];
                
                if(element){
                    element.OnPageClose();
                }
            }
        }
        this.pageMap = {};
    }

    /**
     * 显示模态选择框
     * @param title 标题
     * @param explain 说明
     * @param items 选项数组
     * @param isCancel 是否可以取消
     * @param parentNode 指定父节点
     * @return Promise<number> 选择的index,小于0为取消
     */
    async showSelectBox(title: string, explain: string, items: string[], isCancel: boolean = true, parentNode?: cc.Node): Promise<number> {

        const page = await this.OpenPage<o1SelectBox>(PAGE.DIALOG_SELECT,UI_Z_INDEX.DIALOG);
        return page.showSelectBox(title, explain, items, isCancel);
    }

    /**
     * 显示消息
     * @param message 消息文本
     * @param parentNode 父节点
     * @param 显示时间
     * */
    showMessageBox(
        message: string
        , parentNode: cc.Node = null
        , showTime: number = 2
        , showPosY: number = 350
    ) {
        if (!parentNode) {
            parentNode = this.getUIRoot().getChildByName("Message");
            parentNode.y = showPosY;
        }
        this.m_frameBundle.load(`${this.m_pathPreloadFrame}/o1MessageBox`, cc.Prefab, (error, assets: cc.Prefab) => {
            if (error) {
                console.error('#40错误 错误消息框预制体', error);
                return;
            }
            //
            let node = cc.instantiate(assets);
            node.getComponent(o1MessageBox).showMessageBox(message, showTime);
            parentNode.addChild(node, UI_Z_INDEX.MESSAGE);
        })
    }

    private isOKRightOrUnderlie: boolean = true;
    // CP -按钮交换位置模式   DS -取消按钮延迟显示模式   CC -默认勾选看视频领奖励模式
    private readonly dlgBoxName_VD: string[] = ["o1DialogBox_VD_CP", "o1DialogBox_VD_DS", "o1DialogBox_VD_CC"];

    /**
     * 显示模态对话框 看视频按钮请注意文本长度 要 与取消文本所在按钮同大小
     * @param title 标题
     * @param message 文本
     * @param isCancelOk 是否有取消按钮
     * @param clickCallBack 点击回调 是否确定
     * @param parentNode 父节点
     * @param okButtonText 确定按钮自定义文本
     * @param cancelButtonText 取消按钮自定义文本
     * @param lookVideoCount 观看视频次数
     * @param ovVideoAdPatternIndex ov平台激励视频弹窗样式选择，无输入则随机： 0 -CP  1 -DS  2 -CC
     * @param lookVideoSource 观看视频目的
     * */
    showDialogBox(title: string, 
                  message: string,
                  isCancelOk: boolean = false,
                  clickCallBack?: (isOk: boolean) => void,
                  parentNode: cc.Node = null,
                  okButtonText?: string,
                  cancelButtonText?: string,
                  lookVideoCount?: number,
                  ovVideoAdPatternIndex: number = null,
                  lookVideoSource?: string) {
        parentNode = parentNode || this.getUIRoot();
        //
        const prams : IDialogPrams = {
            title:title,
            message:message,
            isCancelOk:isCancelOk,
            clickCallBack:clickCallBack,
            okButtonText:okButtonText,
            cancelButtonText:cancelButtonText,
            lookVideoCount:lookVideoCount,
            lookVideoSource:lookVideoSource,
        }
        this.OpenPage(PAGE.DIALOG_DIALOG,UI_Z_INDEX.DIALOG,prams);
    }

    private m_loadingNode: cc.Node = null;
    private m_loadingOver: boolean = false;

    /**
     * 显示加载
     * @param parentNode 父节点
     * @param loadingText 加载文本
     * */
    async showLoading(parentNode: cc.Node = null, loadingText: string = '正在加载') {
        return new Promise<void>(resolve => {
            this.m_loadingOver = false;
            parentNode = parentNode || this.getUIRoot();
            this.m_frameBundle.load(`${this.m_pathPreloadFrame}/o1Loading`, cc.Prefab, (error, assets: cc.Prefab) => {
                if (error) {
                    console.error('#40错误 错误对话框加载', error);
                    return resolve();
                }
                if (this.m_loadingOver) {
                    this.hideLoading();
                    return resolve();
                }
                if (this.m_loadingNode) {
                    if (this.m_loadingNode.isValid) {
                        this.m_loadingNode.removeFromParent(false);
                    } else {
                        this.m_loadingNode.destroy();
                        this.m_loadingNode = null;
                    }
                }
                if (!this.m_loadingNode) {
                    this.m_loadingNode = cc.instantiate(assets);
                }
                this.m_loadingNode.getComponent(o1Loading).showLoading(loadingText)
                parentNode.addChild(this.m_loadingNode, UI_Z_INDEX.LOADING);
                resolve();
            })
        });
    }

    /**
     * 展示无限体力界面
     * @param showProbability 展示无限体力的概率 1为必现  已经有无限体力不会展示
     * @param parentNode 父节点
     */
    showInfinityPower(showProbability: number, parentNode: cc.Node) {
        let dateOld = O1HD.getServices().localStorageSrv.getStorage(this.InfinityPower_Key);
        if (dateOld) {
            let rand = Math.random();
            if (Number(O1HD.getServices().localStorageSrv.getStorage(this.InfinityModel)) == 0) {
                if (rand < showProbability) {
                    this.createAndShowInfinityPower(parentNode);
                }
            } else {
                this.showMessageBox('今日已经解锁');
            }
        } else {
            //todo 第一次登陆
            O1HD.getServices().localStorageSrv.setStorage(this.InfinityPower_Key, Date.now());
            this.createAndShowInfinityPower(parentNode);
        }
    }

    /**
     * 获取金币体力钻石等
     * @param rewardType 奖励类型
     * @param rewardCount 数量
     * @param parentNode 父节点
     */
    showUserPropGet(rewardType: REWARD_TYPE, rewardCount: number, parentNode?: cc.Node, overCb?: () => void) {
        // this.showFramePrefab('preload/control/addUserProp', parentNode, true, node => {
        //     node.getComponent(addUserProp).setData(rewardType, rewardCount);
        //     overCb && overCb();
        // });
        const prams : IAddUserPropPrams = {
            propType: rewardType,
            propNumber: rewardCount
        }
        this.OpenPage(PAGE.DIALOG_ADDUSERPROP,UI_Z_INDEX.DIALOG,prams);
        overCb&&overCb();
    }

    /***
     * 显示获得的奖励
     * @param rewardType 奖励类型
     * @param rewardCount 奖励数量
     * @param titleString 奖励标题
     * @param customSpriteFrame 奖励图片
     * @param parentNode 父节点
     * @constructor
     */
    showGetRewarded(rewardType: REWARD_TYPE, rewardCount: number, titleString?: string, customSpriteFrame?: cc.SpriteFrame, parentNode?: cc.Node) {
        // parentNode = parentNode || this.getUIRoot();
        // this.showFramePrefab('preload/control/RewardView', parentNode, true, node => {
        //     node.getComponent(RewardView).OnShowReward(rewardType, rewardCount, titleString, customSpriteFrame);
        // })
        const prams : IRewardViewPrams = {
            rewardType: rewardType,
            rewardCount: rewardCount,
            titleString: titleString
        }
        this.OpenPage(PAGE.DIALOG_REWARDVIEW,UI_Z_INDEX.DIALOG,prams);
    }

    /**
     * 展示无限体力界面
     * @param parentNode 父节点
     */
    private createAndShowInfinityPower(parentNode: cc.Node) {
        // const prams : IPagePramsBase = {

        // }
        this.OpenPage(PAGE.DIALOG_INFINITYPOWER,UI_Z_INDEX.DIALOG);
    }

    /**
     * 隐藏加载
     * */
    hideLoading() {
        this.m_loadingNode && this.m_loadingNode.isValid && this.m_loadingNode.destroy();
        this.m_loadingNode = null;
        this.m_loadingOver = true;
    }

    getFrameBundlePath() {
        return this.m_pathFrameBundle;
    }

    getFontBundlePath() {
        return this.m_publicFontBundle;
    }

    getGameBundlePath() {
        return this.m_pathGameBundle;
    }

    setFrameBundle(bundle: cc.AssetManager.Bundle) {
        this.m_frameBundle = bundle;
    }

    setGameBundle(bundle: cc.AssetManager.Bundle) {
        this.m_gameBundle = bundle;
    }

    getFrameBundle() {
        return this.m_frameBundle;
    }

    getGameBundle() {
        return this.m_gameBundle;
    }

    /**
     * 显示预制体
     * @param inPrefabPath 预制体在子包的路径
     * @param parentNode 父节点
     * @param isShowLoading 显示/不显示 加载条
     * @param addedCallback 成功回调
     */
    showFramePrefab(inPrefabPath: string, parentNode?: cc.Node, isShowLoading?: boolean, addedCallback?: (node: cc.Node) => void) {
        //
        parentNode = parentNode || this.getUIRoot();
        //
        if (isShowLoading) {
            this.showLoading();
        }
        this.m_frameBundle.load(inPrefabPath, cc.Prefab, (error, assets: cc.Prefab) => {
            if (isShowLoading) {
                this.hideLoading();
            }
            if (error) {
                console.error('#446 错误 ui加载预制体', inPrefabPath);
                return;
            }
            //
            if (parentNode && parentNode.isValid) {
                let node = cc.instantiate(assets);
                parentNode.addChild(node);
                addedCallback && addedCallback(node);
            } else {
                console.error('#453 错误 ui 父节点已失效', inPrefabPath, Date.now());
            }
        })
    }

    /**
     * 显示隐藏对话框动画
     * @param node 目标节点
     * @param isShow 显示为真 隐藏为假
     * @param cb 动画完成回调
     */
    showHideDialogAnimation(node: cc.Node, isShow: boolean, cb?: () => void) {
        //
        if (node && node.isValid) {
            const SCALE_TIME = 0.26;
            if (isShow) {
                node.scale = 0;
                cc.tween(node)
                    .parallel(
                        cc.tween(node).to(SCALE_TIME, {scale: 1}),
                        cc.tween(node)
                            .by(SCALE_TIME * 0.45, {y: 250}, {easing: 'cubicOut'})
                            .by(SCALE_TIME * 0.55, {y: -250}, {easing: 'cubicIn'})
                    )
                    .call(cb)
                    .start();
            } else {
                cc.tween(node)
                    .parallel(
                        cc.tween(node).to(SCALE_TIME, {scale: 0}),
                        cc.tween(node)
                            .by(SCALE_TIME * 0.55, {y: 250}, {easing: 'cubicOut'})
                            .by(SCALE_TIME * 0.45, {y: -250}, {easing: 'cubicIn'})
                    )
                    .call(cb)
                    .start();
            }
        }
    }
}




























